import { OnInit, ElementRef, Renderer2, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { MenuService } from './app.menu.service';
import { Store, select } from '@ngrx/store';
import { selectCurrentUser } from '@app/store/user/user.selectors';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss'],
    encapsulation: ViewEncapsulation.None // ← Importante
})
export class AppMenuComponent implements OnInit, OnDestroy {
    model: any[] = [];
    private destroy$ = new Subject<void>();

    constructor(
        public layoutService: LayoutService,
        public menuService: MenuService,
        private store: Store,
        private renderer: Renderer2
    ) { }

    ngOnInit() {
        this.menuService.ensureMenuLoaded().subscribe(() => {
            this.model = this.menuService.getMenuData();
        });

        // Obtener el color de la empresa y aplicarlo
        this.store.pipe(
            select(selectCurrentUser),
            filter(user => !!user),
            takeUntil(this.destroy$)
        ).subscribe(user => {
            if (user?.company?.color) {
                this.applyCompanyColor(user.company.color);
            } else {
                this.applyCompanyColor('#3b82f6'); // Color por defecto
            }
        });
    }

    applyCompanyColor(color: string) {
    // Aplicar al documento root
    document.documentElement.style.setProperty('--company-color', color);
    
    // Para el fondo claro, usar rgba con más opacidad
    const lightColor = this.hexToRgba(color, 0.15);
    document.documentElement.style.setProperty('--company-color-light', lightColor);
    
    // Para el hover, oscurecer un poco más
    const hoverColor = this.darkenColor(color, 15);
    document.documentElement.style.setProperty('--company-color-hover', hoverColor);
}

    // Convierte hex a rgba
    hexToRgba(hex: string, alpha: number): string {
        // Eliminar el # si existe
        hex = hex.replace('#', '');
        
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    // Oscurece un color
    darkenColor(hex: string, percent: number): string {
        hex = hex.replace('#', '');
        const num = parseInt(hex, 16);
        const amt = Math.round(2.55 * percent);
        
        const R = Math.max(0, Math.min(255, (num >> 16) - amt));
        const G = Math.max(0, Math.min(255, ((num >> 8) & 0x00FF) - amt));
        const B = Math.max(0, Math.min(255, (num & 0x0000FF) - amt));
        
        return '#' + (
            (1 << 24) +
            (R << 16) +
            (G << 8) +
            B
        ).toString(16).slice(1);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}